// Verification page content — real official crypto addresses.
export const BRAND = 'Zukunft Real Estate GmbH';
export const BRAND_MONOGRAM = 'ZR';
export const DOMAIN = 'zukunft-realestates.com';

export const ADDRESSES = [
  {
    key: 'btc',
    icon: 'btc',
    address: 'bc1qpz72rgz5nvf3grmyzmvhv8srgp0vsqn7qssqha',
  },
  {
    key: 'eth',
    icon: 'eth',
    address: '0xffAa08A3Af34588f16789FF98605a5A1A06f7d80',
  },
  {
    key: 'trx',
    icon: 'trx',
    address: 'TCVfYT6yhhqqiyjhbbBSGuZExjPPnq5qvH',
  },
];
